import { displayToastError, http } from 'app';

export const getUsageReport = async (
  startDate: string,
  endDate: string
): Promise<any> => {
  try {
    const response = await http.get(
      '/portal/usage/reports?startDate=:startDate&endDate=:endDate'
        .replace(':startDate', startDate)
        .replace(':endDate', endDate),
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
    return response.data;
  } catch (error: any) {
    const errorMessage = error.response.data.message;
    displayToastError(String(errorMessage), 'Usage');
  }
};
